import styles from "./styles.module.scss";

const EntryBlock = () => {
  return (
    <section className={styles.Container}>
      <div className="container">
        <div className={styles.EntryBlock}>

          <div className={styles.EntryBlock_info}>
            <h1>Виртуальные <span>бэйджи</span></h1>
            <p className={styles.EntryBlock_info__thin}>
              Виртуальные бэйджи! Отмечайте свои донации, совершайте пожертвования, привлекайте друзей в проект — открывайте уникальные ачивки! Доноры сообщества DonorSearch могут собирать эксклюзивные виртуальные значки, отмечающие достижения на пути донора и вклад в развитие донорства. Присоединяйтесь к сообществу доноров, мы регулярно добавляем новые бэйджи за активности на платформе DonorSearch.org.
            </p>
          </div>

          <div className={styles.EntryBlock_img}>
            <img src="/static/images/achievements/kind_heart/kind_heart_gold_2025.png" alt="ачивки" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default EntryBlock;
